import {Keys} from 'react-keydown';

const {ENTER, UP, DOWN, ESC} = Keys;

export const keys = [ENTER, UP, DOWN, ESC];
